export default __webpack_public_path__ + "static/media/Learn.7707df35.png";